<template>
  <div class="nav__email-signup">
    <aside class="nav__email-signup__lightbox" :style="lightboxStyle">
      <button class="nav__email-signup__close" @click="closeClicked"><span>Close</span></button>
      <div class="nav__email-signup__wrapper">
        <h2>Subscribe to ShopKeep's Small Business Hub</h2>
        <marketo
          id="1273"
          class-name="mktoSolid"
          cta="Subscribe"
        ></marketo>
      </div>
      <a class="nav__email-signup__rss" href="http://feeds.feedburner.com/shopkeep/BZWt" target="_blank">Small Business Hub Feed</a>
    </aside>
  </div>
</template>

<script>
import marketo from './sk-marketo.vue';

export default {
    components: {
      marketo
    },
    data(){
        return {
          shouldShowLightbox: false,
        };
    },
    computed: {
      lightboxStyle(){
        return {
          display: this.shouldShowLightbox ? 'block' : 'none',
        };
      },
    },
    methods: {
      subscribeClicked(){
        this.shouldShowLightbox = !this.shouldShowLightbox;

        dataLayer.push({
          event: 'popup',
          popupType: 'Web Form',
          popupAction: 'Click',
          popupLabel: this.subscribeButtonText
        });
      },
      closeClicked(){
        this.shouldShowLightbox = false;

        dataLayer.push({
          event: 'popup',
          popupType: 'Web Form',
          popupAction: 'Click',
          popupLabel: this.subscribeButtonText
        });
      },
    }
};
</script>